import { render, staticRenderFns } from "./Idp.vue?vue&type=template&id=562c8d65&scoped=true&"
import script from "./Idp.vue?vue&type=script&lang=js&"
export * from "./Idp.vue?vue&type=script&lang=js&"
import style0 from "./Idp.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Idp.vue?vue&type=style&index=1&id=562c8d65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562c8d65",
  null
  
)

export default component.exports